<script setup>

import HackathonHeaderSvg from '@images/hackathon-header.svg';

</script>

<template>
  <img
    class="mw-100 mh-100 object-fit-contain"
    :src="HackathonHeaderSvg"
    alt="Hackathon banner"
  >
</template>
